module.exports = __webpack_public_path__ + "img/search-icon1.7145fa23.svg";